import {useMemo} from 'react';

import {publicAssetUrl} from '../../../config';
import {type RunFiles_DirectUrlFragment as FileWithDirectUrl} from '../../../generated/graphql';

export function useNetronUrl(
  file: FileWithDirectUrl | null | undefined,
  telemetry: boolean
): string | null {
  return useMemo(() => {
    if (!file) {
      return null;
    }
    const url = new URL(
      publicAssetUrl('/netron/index.html'),
      window.location.origin
    );
    url.searchParams.append('url', file.directUrl);
    url.searchParams.append('identifier', file.name);
    if (telemetry) {
      url.searchParams.append('telemetry', '1');
    }

    return url.origin === window.location.origin
      ? url.pathname + url.search
      : url.href;
  }, [file, telemetry]);
}
